import React from 'react';
import { Hero } from '../components/Hero';
import { Awareness } from '../components/Awareness';
import { About } from '../components/About';
import { WaysToWork } from '../components/WaysToWork';
import { FinalCTA } from '../components/FinalCTA';
export function Home() {
  return <>
      <Hero data-id="element-839" data-mp="2x5g2uez7h5g1" />
      <Awareness data-id="element-840" data-mp="2x5z92yfhu5e8" />
      <About data-id="element-841" data-mp="2x4efpc4x0shy" />
      <WaysToWork data-id="element-842" data-mp="2x568kf74oc4j" />
      <FinalCTA data-id="element-843" data-mp="2x7sl6t8vlhtm" />
    </>;
}